define.alias("@ember/render-modifiers/modifiers/will-destroy", "calendar/modifiers/will-destroy");